import moment from "moment-timezone"
import { normalizeAdminListFilters } from "helpers/adminListQueryPolicy"

export const DEFAULT_LEAD_OPTIONS = { page: 1, limit: 25, sortBy: "createdAt:desc" }
export const LEAD_SORT_OPTIONS = [
  { value: "createdAt:desc", label: "Newest first" },
  { value: "createdAt:asc", label: "Oldest first" },
  { value: "clubName:asc", label: "Club name A–Z" },
  { value: "clubName:desc", label: "Club name Z–A" },
  { value: "leadId:desc", label: "Lead ID descending" },
  { value: "leadId:asc", label: "Lead ID ascending" },
]
const FILTER_KEYS = ["search", "location", "sportType", "status", "fromDate", "toDate"]

export const readLeadQuery = search => {
  const params = new URLSearchParams(search)
  const filters = normalizeAdminListFilters(Object.fromEntries(
    FILTER_KEYS.map(key => [key, params.get(key)])
  ))
  const page = Number(params.get("page"))
  const limit = Number(params.get("limit"))
  const sortBy = params.get("sortBy")
  return {
    filters,
    options: {
      page: Number.isInteger(page) && page > 0 && page <= 100000 ? page : 1,
      limit: [25, 50, 100].includes(limit) ? limit : 25,
      sortBy: LEAD_SORT_OPTIONS.some(option => option.value === sortBy) ? sortBy : DEFAULT_LEAD_OPTIONS.sortBy,
    },
  }
}

export const writeLeadQuery = (filters, options) => {
  const params = new URLSearchParams(normalizeAdminListFilters(filters))
  Object.entries(options).forEach(([key, value]) => {
    if (value !== DEFAULT_LEAD_OPTIONS[key]) params.set(key, value)
  })
  return params.toString() ? `?${params}` : ""
}

export const leadDateError = ({ fromDate, toDate }) => {
  if ([fromDate, toDate].some(value => value && !moment(value, "YYYY-MM-DD", true).isValid())) {
    return "Enter valid creation dates."
  }
  return fromDate && toDate && fromDate > toDate
    ? "Created from must be on or before Created to."
    : ""
}
